import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const List14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.3 1.25C1.7201 1.25 1.25 1.7201 1.25 2.3V4.7C1.25 5.2799 1.7201 5.75 2.3 5.75H4.7C5.2799 5.75 5.75 5.2799 5.75 4.7V2.3C5.75 1.7201 5.2799 1.25 4.7 1.25H2.3ZM2.75 4.25V2.75H4.25V4.25H2.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.3 8.25C1.7201 8.25 1.25 8.7201 1.25 9.3V11.7C1.25 12.2799 1.7201 12.75 2.3 12.75H4.7C5.2799 12.75 5.75 12.2799 5.75 11.7V9.3C5.75 8.7201 5.2799 8.25 4.7 8.25H2.3ZM2.75 11.25V9.75H4.25V11.25H2.75Z'
      fill='currentColor'
    />
    <path d='M14 2.75H7V1.25H14V2.75Z' fill='currentColor' />
    <path d='M7 9.75H14V8.25H7V9.75Z' fill='currentColor' />
    <path d='M12 5.75H7V4.25H12V5.75Z' fill='currentColor' />
    <path d='M7 12.75H12V11.25H7V12.75Z' fill='currentColor' />
  </Svg>
);

List14.displayName = 'List14';
export default List14;
